import { AddBlockDropdownButton } from '@anyx/feature-crm/shared';

import { BlockTitle } from '../block-title';
import { LineMessageBlockType } from '../types';

const BROADCAST_DROPDOWN_ITEMS = [
  LineMessageBlockType.enum.PLAIN_TEXT,
  LineMessageBlockType.enum.RICH,
  LineMessageBlockType.enum.BUTTON,
  LineMessageBlockType.enum.IMAGES,
];

export interface AddLineMessageBlockProps {
  onAdd: (type: LineMessageBlockType) => void;
}

export const AddLineMessageBlock = ({ onAdd }: AddLineMessageBlockProps) => {
  return (
    <AddBlockDropdownButton
      blocks={BROADCAST_DROPDOWN_ITEMS}
      onAdd={onAdd}
      renderBlockNode={(type) => <BlockTitle type={type} />}
    />
  );
};
